export class VariablesConstant {
  public static readonly MENU_STATUS = [
    { label: "Active", value: "Y", labelKr: "활성" },
    { label: "Inactive", value: "N", labelKr: "비활성" },
  ];

  // public static readonly CONNECTION_STATUS = [
  //   { label: "Active", value: "Y", labelKr: "활동적인" },
  //   { label: "Inactive", value: "N", labelKr: "멈추다" },
  // ];

  public static readonly DEFAULT_MENU_STATUS = "N";

  // public static readonly DEFAULT_CONNECTION_STATUS = "N";

  public static readonly DEFAULT_COMM_CODE_STATUS = "N";

  public static readonly COMM_CD_STATUS = [
    { label: "Active", value: "Y", labelKr: "활성" },
    { label: "Inactive", value: "N", labelKr: "비활성" },
  ];

  public static readonly ACTIVE_STATUS = [
    { label: "Active", value: "Y", labelKr: "활성" },
    { label: "Inactive", value: "N", labelKr: "비활성" },
  ];

  public static readonly DEFAULT_ACTIVE_STATUS = "N";
  public static readonly ACTIVE_STATUS_VAL = "Y";
  public static readonly INACTIVE_STATUS_VAL = "N";

  public static readonly GEN = [
    { label: "Male", value: "1", labelKr: "남성" },
    { label: "Female", value: "0", labelKr: "여성" },
  ];

  public static readonly CRON_EXPRESSION = [
    { label: "Every second", value: "*/1 * * * * ?", labelKr: "매초" },
    { label: "Every 10 seconds", value: "*/10 * * * * ?", labelKr: "매 10초마다" },
    { label: "Every 30 seconds", value: "*/30 * * * * ?", labelKr: "30초마다" },
    { label: "Every minute", value: "0 * * * * ?", labelKr: "매분" },
  ];

  public static readonly PROTOCOL_MODBUS = "MODBUS_V1_0";
  public static readonly PROTOCOL_MQTT = "MQTT_V1_0";
  public static readonly PROTOCOL_OPC_UA = "OPC_UA_V1_0";
  public static readonly PROTOCOL_IEC61850 = "IEC61850_V1_0";
  public static readonly PROTOCOL_DNP3 = "DNP3_V1_0";

  public static readonly PROTOCOL_MODBUS_NAME = "Modbus";
  public static readonly PROTOCOL_MQTT_NAME = "MQTT";
  public static readonly PROTOCOL_OPC_UA_NAME = "OPC-UA";
  public static readonly PROTOCOL_IEC61850_NAME = "IEC61850";
  public static readonly PROTOCOL_DNP3_NAME = "DNP3";
  public static readonly PROTOCOL_AIS_NAME = "AIS";
  public static readonly PROTOCOL_COAP_NAME = "CoAP";

  public static readonly UA_CONNECT_TP_TCP = "07-01";
  public static readonly UA_CONNECT_TP_HTTPS = "07-02";

  public static readonly DEVICE_CONNECTION_STATUS_CONNECTED = "08-01";
  public static readonly DEVICE_CONNECTION_STATUS_NOT_CONNECTED = "08-02";

  public static readonly CONTAINER_RUNNING = "09-01";
  public static readonly CONTAINER_STOPPED = "09-02";

  public static readonly INSTANCE_TYPE_DELIVERY = "10-01";
  public static readonly INSTANCE_TYPE_COLLECTION = "10-02";

  public static readonly CONNECTION_STATUS_NEW = "11-01";
  public static readonly CONNECTION_STATUS_RUNNING = "11-02";
  public static readonly CONNECTION_STATUS_STOPPED = "11-03";

  public static readonly COLLECTION_INSTANCE_STOPPED = "12-01";
  public static readonly DELIVERY_INSTANCE_STOPPED = "12-02";
  public static readonly COLLECTION_CONNECT_KAFKA_FAILED = "12-03";
  public static readonly DELIVERY_CONNECT_KAFKA_FAILED = "12-04";
  public static readonly COLLECTION_DEVICE_STOPPED = "12-05";
  public static readonly DELIVERY_CONNECT_DATABASE_FAILED = "12-06";

  public static readonly CELL_VAL_COL_NAME = "Column Name";
	public static readonly CELL_VAL_OFFSET = "Offset";
	public static readonly CELL_VAL_FIELD = "Field";
	public static readonly CELL_VAL_NS_IDX = "Namespace Index";
	public static readonly CELL_VALUE_INDEX = "Value Index";
	public static readonly CELL_PATH_VALUE = "Path Value";
	public static readonly CELL_VAL_IDENTIFIER = "Identifier";
	public static readonly CELL_VAL_AIS = "AIS Field";
	public static readonly CELL_VAL_COAP = "CoAP Field";

  public static readonly VIEW_LST_CONNECTION = "VIEW_LST_CONNECTION";
  public static readonly VIEW_DETAILS_CONNECTION = "VIEW_DETAILS_CONNECTION";

  public static readonly DATA_MAP_FORM = "DATA_MAP_FORM";
}
